import { global } from ":shared/app";

export type GET = {
  returns: {
    team_name: string;
    track: string;
    team_members: {
      id: number;
      name: string;
      image: string;
    }[];
    project_name: string;
    project_images: string;
    presentation: string;
    ideation: string;
    project_cover: string;
  }[];
};
export const endpoint = "teaming/teams/exhibition/";
export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(import("./exhibition.mock")).then((r) => {
  //   return r.success;
  // });
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      // message: service.api.decode_error(err, "couldn't update password"),
      return Promise.reject(err.message);
    });
}
